// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e384ee63","453":"1533aba4","796":"cffb3209"}[chunkId] + ".chunk.js";
};